import React from 'react'
import './../App.css'

const Footer = () => {
    const corsTester =  async ()=>{
      await fetch('https://landingpageserver.vercel.app/email/send', {
        method:'POST',
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({name:'kola'})
      })
      .then(res=> {
        const result = res.json();
        alert(`Call 747 249 8760 ${result}`)
      })
      .catch(err => console.error(err));
      alert(`Call 747 249 8760 or fill the Form`)

    }
  return (
    <>
    <div className='footerContainer'>
      <div className='footerContents'>
          <div className="footerContentleft">
              <div className="footerContentleftdiv">
              <img src="/assets/image.png" className="footerImage"  alt="Logo" />
              </div>
              <div>
                <img src="/assets/footerimg.jpg" className="footerImg" alt="softwaredevbytes" />
              </div>
          </div>
          <div className="footerContentright">
              <h2>Have More Questions?</h2>
              <p>Speak with an Enrollment Staff to discuss how Software DevBytes 
                  can assist you with your career change.
              </p>
              <button type='button' onClick={()=>corsTester()}>Talk to Our Admission Staff</button>
          </div>
      </div>
     <div className="copyright">
            <p>&copy;  {`${new Date().getFullYear()}`} <a href="https://www.softwaredevbytes.com">SOFTWARE DEV BYTES.</a></p>
            <div className='copyrightElement'>
                <p>All rights reserved</p>
                <a href='https://www.softwaredevbytes.com/privacy'>Privacy Policy</a>  | <a href='https://www.softwaredevbytes.com/privacy'>Terms</a> 
            </div>
        </div>
    </div>
    </>
  )
}

export default Footer